<template>
  <div class="thankyou">


<b-jumbotron style="margin:auto;width:50%" container-fluid>
      <div v-if="lang == 'en'">
        <strong><p>
        Thank you for participating in our study!
      </p></strong>
        <p>
        If you have any comments or questions, please write to the <span class="codedirection">moc.liamg@silavin.aletsum</span> email address to Tamás Faragó!
        </p>
      </div>
      <div v-if="lang == 'hu'">
        <strong><p>
      Köszönjük, hogy részt vettél a kutatásunkban!
    </p></strong>
        <p>
      Ha bármi kérdésed vagy észrevételed van, kérjük írj a <span class="codedirection">moc.liamg@silavin.aletsum</span> email címre Faragó Tamásnak!
        </p>
      </div>
  </b-jumbotron>

  <!-- <router-link :to="{ name: 'Results' }">
  <b-button  style="outline: none !important;   box-shadow: none;">skip to results (testing only)</b-button>
  </router-link> -->
  </div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'thankyou',
  computed: mapState([
    'lang'
  ]),
  methods: mapMutations(['changeLang'])
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Thankyou.vue